import { Fragment } from "react";
import { Box, Typography } from "@material-ui/core";
import * as textConstants from "./constants";
import { CallState } from "@hopper-b2b/types";
import "./styles.scss";
import { ActionButton, B2BSpinner, Icon, IconName } from "@hopper-b2b/ui";
import { StopWatchingModalContentConnectorProps } from "./container";
import clsx from "clsx";
import { WatchAlertView } from "@b2bportal/air-price-watch-api";

interface IStopWatchingModalContentProps
  extends StopWatchingModalContentConnectorProps {
  onClose: () => void;
}

export const StopWatchingModalContent = ({
  openModal,
  deleteWatch,
  deleteWatchCallState,
  setDeleteWatchCallState,
  onClose,
}: IStopWatchingModalContentProps) => {
  const getModalContent = () => {
    switch (deleteWatchCallState) {
      case CallState.InProcess:
        return <B2BSpinner />;
      case CallState.Failed:
        return (
          <Fragment>
            <Typography className="stop-watching-title" variant="h2">
              {textConstants.STOP_WATCHING_FAILURE_TITLE}
            </Typography>
            <Typography className="stop-watching-subtitle" variant="h5">
              {textConstants.STOP_WATCHING_FAILURE_SUBTITLE}
            </Typography>
            <Box className="stop-watching-buttons">
              <ActionButton
                className={clsx("stop-watching-button", "b2b")}
                onClick={() => {
                  setDeleteWatchCallState(CallState.NotCalled);
                }}
                message={textConstants.RETRY_CTA}
                defaultStyle="h4r-primary"
              />
              <ActionButton
                className="cancel-button"
                onClick={() => onClose()}
                message={textConstants.CANCEL_CTA}
                defaultStyle="h4r-secondary"
              />
            </Box>
          </Fragment>
        );
      case CallState.Success:
        return (
          <Fragment>
            <Box className="icon-wrapper">
              <Icon name={IconName.Checked} ariaLabel="" className="icon" />
            </Box>
            <Typography className="stop-watching-title" variant="h2">
              {textConstants.STOP_WATCHING_SUCCESS}
            </Typography>
            <Box className="stop-watching-buttons">
              <ActionButton
                className={clsx("cancel-button", "b2b")}
                onClick={() => onClose()}
                message={textConstants.DONE_CTA}
                defaultStyle="h4r-primary"
              />
            </Box>
          </Fragment>
        );
      default:
        return (
          <Fragment>
            <Typography className="stop-watching-title" variant="h2">
              {textConstants.STOP_WATCHING_TITLE}
            </Typography>
            <Typography className="stop-watching-subtitle" variant="h5">
              {textConstants.STOP_WATCHING_SUBTITLE}
            </Typography>
            <Box className="stop-watching-buttons">
              <ActionButton
                className={clsx("stop-watching-button", "b2b")}
                onClick={() => {
                  deleteWatch(openModal.selectedItinerary as WatchAlertView);
                }}
                message={textConstants.STOP_WATCHING_CTA}
                defaultStyle="h4r-primary"
              />
              <ActionButton
                className="cancel-button"
                onClick={() => onClose()}
                message={textConstants.CANCEL_CTA}
                defaultStyle="h4r-secondary"
              />
            </Box>
          </Fragment>
        );
    }
  };
  return <Box className="stop-watching-modal-content">{getModalContent()}</Box>;
};
